import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { compose } from 'redux';
import { FormattedMessage } from 'react-intl';

import { DefaultButton } from 'common/components';
import { withTheme } from 'common/styling/theme';
import { rejectRewards } from '../../_redux';

import { staticStyles, getDynamicStyles } from './style';

const RejectRewardsForm = ({
  selectedRecords,
  filter,
  handleSubmit,
  toggleRejectRewardsModal,
  submitting,
  invalid,
  error,
  theme,
  dispatch,
}) => {
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;

  const totalAmount = selectedRecords.reduce((acc, cur) => acc + Number(cur.availableAmount.amount), 0);
  const submit = handleSubmit(values =>
    rejectRewards({ ...values, filter, commissionIds: selectedRecords.map(item => item.id) }, dispatch)
  );

  return (
    <form className="RejectRewardsForm" onSubmit={submit}>
      <div className="RejectRewardsForm__line">
        <FormattedMessage id="justRewardsSelected">
          {txt => <span className="RejectRewardsForm__title">{txt}</span>}
        </FormattedMessage>
        <span>{selectedRecords.map(item => item.id).join(', ')}</span>
      </div>
      <div className="RejectRewardsForm__line">
        <FormattedMessage id="justAmount">
          {txt => <span className="RejectRewardsForm__title">{txt}</span>}
        </FormattedMessage>
        <span>{`${totalAmount} USD`}</span>
      </div>
      <div className="RejectRewardsForm__line">
        <DefaultButton
          type="submit"
          textId="justRejectRewards"
          loading={submitting}
          disabled={invalid || submitting}
          filled
        />
        <DefaultButton textId="justCancel" onClick={toggleRejectRewardsModal} />
      </div>
      {error && <strong>{error}</strong>}
      <style jsx>{staticStyles}</style>
      <style jsx>{dynamicStyles}</style>
    </form>
  );
};

RejectRewardsForm.propTypes = {
  selectedRecords: PropTypes.array.isRequired,
  filter: PropTypes.object.isRequired,
  toggleRejectRewardsModal: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  error: PropTypes.string,
  theme: PropTypes.object,
};

RejectRewardsForm.defaultProps = {
  error: '',
  theme: {},
};

export default compose(
  withTheme(),
  reduxForm({
    form: 'RejectRewardsForm',
    onSubmitSuccess(result, dispatch, props) {
      props.toggleRejectRewardsModal();
      props.setSelectedRecords([]);
    },
  })
)(RejectRewardsForm);
export { RejectRewardsForm };
